// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"Dashboard_Dashboard__3n0cI"};